import EventEmitter from 'events';
import { logger } from '../utility/telemetry';
/** Folders specific event emitter. */
export class FoldersEventEmitter extends EventEmitter {
    /** Emits the passed in change. */
    emitScopedFolderEvent(uniqueIdToNotify, eventMinusUniqueId, eventName) {
        logger.logVerbose('emitScopedFolderEvent', 'Emitting event', { eventName });
        const arg = { ...eventMinusUniqueId, subscribedUniqueId: uniqueIdToNotify };
        this.emit(eventName, arg);
    }
    /** Emits the passed in change. */
    emitUnscopedFolderEvent(event, eventName) {
        logger.logVerbose('emitUnscopedFolderEvent', 'Emitting event', { eventName });
        this.emit(eventName, event);
    }
}
//# sourceMappingURL=eventEmitter.js.map